let _ = require('lodash');
let computed = require('../computed/account/password-change');

module.exports = {
    setComputedFields (args, state) {
        computed.computeChangePasswordButtonState(state);
        computed.setRepeatPasswordError(state);
    },

    resetUserForm (args, state) {
        state.unset(['account', 'passwordChangeForm', 'isError']);
        state.unset(['account', 'passwordChangeForm', 'error']);
    },

    ifChangePasswordInProcess (args, state, output) {
        if (state.get(['account', 'passwordChangeForm', 'inProcess'])) {
            return output.yes();
        }
        return output.no();
    },

    changePassword (args, state, output, { locator, context }) {
        let password = state.get(['account', 'passwordChangeForm', 'password']);
        let passwordNew = state.get(['account', 'passwordChangeForm', 'passwordNew']);

        let API = locator.resolve('api');
        let request = API.passwordChangeActual(context, { password, passwordNew } );

        request.then((data) => {
            let code = _.get(data, 'status.code');

            if (code === 422) {
                output.wrongPassword({ code });
                return;
            }

            if (code !== 204) {
                output.error({ code });
                return;
            }

            output.success({ data });
        })
            .catch((error) => output.error({ error }));
    }

};



// WEBPACK FOOTER //
// ./actions/account/password-change.js